import { useFileDialog } from '@vueuse/core';
import qs from 'qs';

const { origin, href } = window.location;
/**
 * 获取链接里的参数
 * @param name  参数名
 */
export function getUrlSearchParam(name) {
  const paramsString = window.location.search.slice(1);
  const searchParams = new URLSearchParams(paramsString);
  return searchParams.has(name) ? searchParams.get(name) : '';
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
  let result = '';
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    const part = encodeURIComponent(propName) + '=';
    if (value !== null && value !== '' && typeof value !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== '' && typeof value[key] !== 'undefined') {
            const params = propName + '[' + key + ']';
            const subPart = encodeURIComponent(params) + '=';
            result += subPart + encodeURIComponent(value[key]) + '&';
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&';
      }
    }
  }
  return result;
}

/**
 * 判断是否是移动端
 */
export function judgeIsMobile() {
  return window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
}

/**
 * 获取倒计时
 * @param {totalSeconds} 单位：s
 */

export function getResidueTime(totalSeconds) {
  const day = parseInt(totalSeconds / 3600 / 24);
  let hour = parseInt((totalSeconds / 3600) % 24);
  let minute = parseInt((totalSeconds / 60) % 60);
  let second = parseInt(totalSeconds % 60); // 秒
  hour = addZero(hour);
  minute = addZero(minute);
  second = addZero(second);
  let residueTime = (day > 0 ? day + ' 天 ' : '') + hour + ':' + minute + ':' + second;
  if (totalSeconds < 0) {
    residueTime = '00:00:00';
  }
  return residueTime;
}

export function addZero(i) {
  return i < 10 ? '0' + i : String(i);
}

/**
 *  获取元素距离顶部高度
 * @param ele html元素
 * @returns
 */
export function heightToTop(ele: any) {
  // ele为指定跳转到该位置的DOM节点
  const root = document.body;
  let height = 0;
  do {
    height += ele.offsetTop;
    ele = ele.offsetParent;
  } while (ele !== root);
  return height;
}

// url参数
export const seriazeParams = (url?: string) => {
  const search = url ? new URL(url).search : location.search;
  const params = {};
  const paramsString = search.slice(1);
  const searchParams = new URLSearchParams(paramsString);
  for (const pair of searchParams.entries()) {
    params[pair[0]] = encodeURIComponent(pair[1]);
  }
  return params;
};

// 删除 url 上的参数，不刷新页面
export function removeUrlParams(keys: Array<string>) {
  let href = location.href;
  keys.forEach((key) => {
    const e = eval(`/&?${key}=[^&#]*/g`);
    href = href.replace(e, '');
  });
  history.replaceState('', '', href); // replaceState 方法不会触发页面刷新，只是导致history对象发生变化，地址栏会有反应
}

export const toLogin = () => {
  window.location.href = `${origin}/ce-common/login?returnUrl=${href}`;
};

/**
 * @description: 选择文件
 * @param {Object} options accept = '', capture = '', multiple = false
 * @return {Promise}
 */
export function selectFiles(options: {
  accept?: string;
  capture?: string;
  multiple?: boolean;
}): Promise<FileList | null> {
  return new Promise((resolve) => {
    const { onChange, open } = useFileDialog(options);
    onChange((files) => {
      resolve(files);
    });
    open();
  });
}

export const getUrlParams = () => {
  return qs.parse(window.location.search, { ignoreQueryPrefix: true });
};

// 空间id
export const getGid = (() => {
  const GID_KEY = 'cert-service:gid';
  let _gid: null | string = sessionStorage.getItem(GID_KEY);
  return (defaultGid?: string) => {
    if (!_gid) {
      const { gid } = getUrlParams();
      if (gid) {
        _gid = gid;
        sessionStorage.setItem(GID_KEY, gid);
      }
    }
    return _gid || defaultGid;
  };
})();

export const getUserPhotoUploadPath = (id: string) => {
  const gid = getGid(import.meta.env.VITE_APP_DEFAULT_GID);
  return `/cadexam/cert/${gid}/user_cover/upload/${id || 'default'}`;
};